"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AclCategoryActionApiMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const acl_category_action_map_entity_1 = require("./acl-category-action-map.entity");
let AclCategoryActionApiMap = class AclCategoryActionApiMap {
    constructor(id, aclCategoryActionId, api, method, createdBy, updatedBy) {
        this.id = id;
        this.aclCategoryActionId = aclCategoryActionId;
        this.api = api;
        this.method = method;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
    }
};
exports.AclCategoryActionApiMap = AclCategoryActionApiMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id" }),
    tslib_1.__metadata("design:type", Number)
], AclCategoryActionApiMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "acl_category_action_id", type: "integer",
    }),
    tslib_1.__metadata("design:type", Number)
], AclCategoryActionApiMap.prototype, "aclCategoryActionId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "api", type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], AclCategoryActionApiMap.prototype, "api", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "method", type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], AclCategoryActionApiMap.prototype, "method", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], AclCategoryActionApiMap.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], AclCategoryActionApiMap.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "varchar", length: 255, nullable: false }),
    tslib_1.__metadata("design:type", String)
], AclCategoryActionApiMap.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "varchar", length: 255, nullable: false }),
    tslib_1.__metadata("design:type", String)
], AclCategoryActionApiMap.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => acl_category_action_map_entity_1.AclCategoryActionMap, (map) => map.id),
    (0, typeorm_1.JoinColumn)({ name: 'acl_category_action_id' }),
    tslib_1.__metadata("design:type", typeof (_c = typeof acl_category_action_map_entity_1.AclCategoryActionMap !== "undefined" && acl_category_action_map_entity_1.AclCategoryActionMap) === "function" ? _c : Object)
], AclCategoryActionApiMap.prototype, "aclCategoryActionMap", void 0);
exports.AclCategoryActionApiMap = AclCategoryActionApiMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("acl_category_action_api_map"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, String, String, String, String])
], AclCategoryActionApiMap);
